import React from 'react';
import { Field, FieldProps } from 'react-final-form';

type IdentityBaseProps = Pick<FieldProps<any, any>, 'validate' | 'parse' | 'format'> & {
  name: string;
};

export type IdentityFieldProps<C extends React.ElementType> = IdentityBaseProps & {
  component: C;
  children?: never;
} & Omit<React.ComponentProps<C>, 'input' | 'meta'>;

/**
 * COMPONENTE
 * Wrapper trasparente per React Final Form Field che non aggiunge logica UI aggiuntiva
 *
 * Scopo principale:
 * - Fornire un'interfaccia consistente per tutti i tipi di campo
 * - Permettere sia render props (children) che component injection
 * - Mantenere la flessibilità di React Final Form senza imposizioni UI
 *
 * Pattern: Identity Function per composizione di campi
 *
 * @param props - Configurazione del campo identity
 * @returns Componente Field di React Final Form con render logic flessibile
 */

export function IdentityDialogField<C extends React.ElementType>({
  name,
  component: Component,
  validate,
  parse,
  format,
  ...rest
}: IdentityFieldProps<C>) {
  return (
    <Field name={name} validate={validate} parse={parse} format={format}>
      {({ input, meta }) => <Component {...(rest as any)} input={input} meta={meta} />}
    </Field>
  );
}
